import {
  API_ERROR,
  GEN_JWT_FROM_AZURE,
  GEN_JWT_FROM_AZURE_FAIL,
  GEN_JWT_FROM_AZURE_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  SOCIAL_LOGIN
} from "./actionTypes";

export const loginUser = (user, navigate, tokenReCaptcha = "") => {
  return {
    type: LOGIN_USER,
    payload: { user, navigate, tokenReCaptcha },
  };
};

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const logoutUser = (history, isAzure) => {
  return {
    type: LOGOUT_USER,
    payload: { history, isAzure },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};

export const genJwtFromAzure = (token,idToken, navigate) => {
  return {
    type: GEN_JWT_FROM_AZURE,
    token,
    idToken,
    navigate,
  };
};

export const genJwtFromAzureSuccess = () => {
  return {
    type: GEN_JWT_FROM_AZURE_SUCCESS,
  };
};

export const genJwtFromAzureFail = error => {
  return {
    type: GEN_JWT_FROM_AZURE_FAIL,
    error,
  };
};
